import React, { FC } from "react";
import { Select } from "antd";
import { IWorkingHours, getFormattedHours } from "./helper";

interface Props {
  selectedHours: IWorkingHours;
  setSelectedHours: (val: IWorkingHours) => void;
}

const WorkingHoursSelector: FC<Props> = ({
  selectedHours,
  setSelectedHours: onChange,
}) => {
  const handleStartHourChange = (value: number) => {
    const startTime = value;
    const endTime = Math.max(startTime, selectedHours.endTime);
    onChange({ startTime, endTime });
  };

  const handleEndHourChange = (value: number) => {
    const endTime = value;
    const startTime = Math.min(endTime, selectedHours.startTime);
    onChange({ startTime, endTime });
  };

  const getTimeOptions = (limit = 0) =>
    Array.from({ length: 24 - limit }, (_, i) => i + limit).map((hour) => (
      <Select.Option key={hour} value={hour}>
        <span style={{ fontSize: '15px' }}>{getFormattedHours(hour)}</span>
      </Select.Option>
    ));

  return (
    <div style={{ display: 'flex', gap: '24px', marginBottom: '16px', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ marginRight: '12px', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
          Start Hour:
        </label>
        <Select
          value={selectedHours.startTime}
          onChange={handleStartHourChange}
          style={{ width: 130, height: 40 }}
          size="large"
        >
          {getTimeOptions()}
        </Select>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ marginRight: '12px', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
          End Hour:
        </label>
        <Select
          value={selectedHours.endTime}
          onChange={handleEndHourChange}
          style={{ width: 130, height: 40 }}
          size="large"
        >
          {getTimeOptions(selectedHours.startTime)}
        </Select>
      </div>
    </div>
  );
};

export default WorkingHoursSelector;
